import { render } from "./uis-check-circle.vue?vue&type=template&id=76ae44ee"
import script from "./uis-check-circle.vue?vue&type=script&lang=js"
export * from "./uis-check-circle.vue?vue&type=script&lang=js"
script.render = render

export default script